import { gql } from '@apollo/client'

export const GET_PAYMENT_PLAN = gql`
  query GetPaymentPlan($person_id: Int!) {
    payment_plan(filter: { person_id: $person_id }) {
      id
      person_id
      unit_occupancy_id
      negotiated_balance
      installment_amount
      total_installment_cycles
      billing_period_frequency
      billing_period_type
      scheduled_start_date
      status
      remaining_balance
    }
  }
`
